/* eslint-disable no-underscore-dangle */
import { createStore, applyMiddleware, compose } from 'redux';
import createSagasMiddlerware from 'redux-saga';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import reducers from './reducers';
import sagas from './sagas';
const sagasMiddleware = createSagasMiddlerware();
// Persist markets data on page change/refresh
const persistConfig = {
    key: 'byo',
    storage,
    whitelist: ['auth', 'slip'],
};
const persistedReducer = persistReducer(persistConfig, reducers);
const composeEnhancers = typeof window === 'object' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : compose;
const enhancer = composeEnhancers(applyMiddleware(sagasMiddleware));
const store = createStore(persistedReducer, enhancer);
sagasMiddleware.run(sagas);
const persistor = persistStore(store);
export { store, persistor };
